import { FaMoon, FaSun } from "react-icons/fa"
import { useThemeContext } from "../../context/ThemeContext"
import { cn } from "../../lib/utils"
import { Button } from "../ui/button"

export default function ThemeToggle({ className }) {
  const { theme, toggleTheme } = useThemeContext()
  const isDarkMode = theme === "dark"
  const nextTheme = isDarkMode ? "light" : "dark"

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={toggleTheme}
      className={cn("border-border bg-surface text-foreground", className)}
      aria-label={`Switch to ${nextTheme} mode`}
      title={`Switch to ${nextTheme} mode`}
    >
      {isDarkMode ? <FaSun /> : <FaMoon />}
    </Button>
  )
}
